export * from './card-view-page-wrapper.component';
